import type { Application } from 'pixi.js';

const FPS_TARGET = 55;
const WINDOW_MS = 3000;
const COOLDOWN_MS = 6000;
/** Render resolution scale steps — only ever steps DOWN (no oscillation) */
const STEPS = [1, 0.85, 0.7] as const;

/**
 * Auto quality scaling for Series S / weak mobiles (docs/06): if the average
 * fps stays under target for 3s, drop the render resolution one step.
 */
export class QualityMonitor {
  private accMs = 0;
  private frames = 0;
  private cooldownMs = 0;
  private step = 0;

  constructor(private readonly app: Application) {}

  update(deltaMS: number): void {
    this.accMs += deltaMS;
    this.frames++;
    this.cooldownMs -= deltaMS;

    if (this.accMs < WINDOW_MS) return;
    const fps = this.frames / (this.accMs / 1000);
    this.accMs = 0;
    this.frames = 0;

    if (fps < FPS_TARGET && this.cooldownMs <= 0 && this.step < STEPS.length - 1) {
      this.step++;
      this.cooldownMs = COOLDOWN_MS;
      const base = window.devicePixelRatio || 1;
      this.app.renderer.resolution = base * STEPS[this.step]!;
      this.app.resize();
    }
  }
}
